var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4225 25C1.7565 25 1.1865 24.7801 0.7125 24.3403C0.2375 23.9014 0 23.3736 0 22.7569V10.5764C0 9.95972 0.2375 9.43195 0.7125 8.99306C1.1865 8.55324 1.7565 8.33333 2.4225 8.33333H4.5V5.55556C4.5 4.00833 5.082 2.69537 6.246 1.61667C7.41 0.537964 8.828 -0.000924735 10.5 1.19116e-06C12.171 1.19116e-06 13.589 0.53889 14.754 1.61667C15.919 2.69445 16.501 4.00741 16.5 5.55556V8.33333H18.5775C19.2435 8.33333 19.8135 8.55324 20.2875 8.99306C20.7625 9.43195 21 9.95972 21 10.5764V22.7569C21 23.3736 20.7625 23.9014 20.2875 24.3403C19.8135 24.7801 19.2435 25 18.5775 25H2.4225ZM10.5 18.75C11.133 18.75 11.666 18.5491 12.099 18.1472C12.533 17.7463 12.75 17.2528 12.75 16.6667C12.75 16.0806 12.533 15.587 12.099 15.1861C11.666 14.7843 11.133 14.5833 10.5 14.5833C9.867 14.5833 9.334 14.7843 8.901 15.1861C8.467 15.587 8.25 16.0806 8.25 16.6667C8.25 17.2528 8.467 17.7463 8.901 18.1472C9.334 18.5491 9.867 18.75 10.5 18.75ZM6 8.33333H15V5.55556C15 4.39815 14.5625 3.41435 13.6875 2.60417C12.8125 1.79398 11.75 1.38889 10.5 1.38889C9.25 1.38889 8.1875 1.79398 7.3125 2.60417C6.4375 3.41435 6 4.39815 6 5.55556V8.33333Z",
    fill: "#2DB0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLock);
export default __webpack_public_path__ + "static/media/blueLock.d1878e0980fcdacec800196f50f80daa.svg";
export { ForwardRef as ReactComponent };